import {
  CORE_LOAD_FLOORS_REQUEST,
  CORE_LOAD_FLOORS_SUCCESS,
  CORE_LOAD_FLOOR_INFO_REQUEST,
  CORE_LOAD_FLOOR_INFO_SUCCESS
} from '../../types'

const initialState = []
export default {
  floors: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FLOORS_REQUEST:
        return initialState

      case CORE_LOAD_FLOORS_SUCCESS:
        if (action.payload[0]) {
          let payload = action.payload[0]
          let floors = []
          for (let i = 0; i < payload.length; i++) {
            floors.push({
              name: payload[i].name,
              buildingName: payload[i].buildingName,
              _id: payload[i]._id
            })
          }
          return floors
        }
        else return [{}]

      default:
        return state
    }
  },
  floorInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FLOOR_INFO_REQUEST:
        return initialState

      case CORE_LOAD_FLOOR_INFO_SUCCESS:
        if (action.payload[0]) {
          let payload = action.payload[0]
          let floorInfo = []
          floorInfo.push({
            _id: payload._id,
            name: payload.name,
            buildingName: payload.buildingName
          })
          return floorInfo
        }
        else return [{}]

      default:
        return state
    }
  }
}






// WEBPACK FOOTER //
// ./src/features/floors/reducer.js